// extracted by mini-css-extract-plugin
export default {"declineModalContent":"DeclineModal_declineModalContent__NT0X-","buttonContainer":"DeclineModal_buttonContainer__PIQf3"};